export enum FixtureStatuses {
  IfNeeded = "IF_NEEDED",
  Scheduled = "SCHEDULED",
  Bye = "BYE",
  Pending = "PENDING",
  InProgress = "IN_PROGRESS",
  Finished = "FINISHED",
  Confirmed = "CONFIRMED",
  Postponed = "POSTPONED",
  Cancelled = "CANCELLED",
  Abandoned = "ABANDONED",
  WarmUp = "WARM_UP",
  OnPitch = "ON_PITCH",
  AboutToStart = "ABOUT_TO_START",
  Draft = "DRAFT",
}
